import HttpEntityClient from '@123/druid/dist/Components/Http/HttpEntityClient';
import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import {type FaqItem, faqItemSchema} from '@Module/Faq/Schema/FaqItem';

@injectable()
export default class FaqService {
    constructor(private entityClient: HttpEntityClient = new HttpEntityClient()) {}

    public async getFaqItem(categoryId: number, questionId: number): Promise<FaqItem> {
        return this.entityClient.get('/help/faq-c' + categoryId + '-q' + questionId + '.json', faqItemSchema);
    }
}
